<template>
    <div class="modal-goodslist" :style="goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">{{header}}</div>
            </div>
            <div class="modal-body" :style="bodyStyle">

                <el-form :model="editForm"  :disabled="disabled" ref="editForm">
                    <div>
                        <el-row>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>基本信息</span>
                                </div>
                                <el-col :span="18">
                                    <el-col :span="8" class="item">
                                        <el-form-item label="姓名" required >
                                            <el-input v-model="editForm.name" placeholder="请输入姓名"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" class="item">
                                        <el-form-item label="身份证号" required >
                                            <el-input v-model="editForm.idCard" maxlength="18" placeholder="请输入身份证号"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" class="item">
                                        <el-form-item label="手机号" required  >
                                            <el-input v-model="editForm.phone" maxlength="11" placeholder="请输入手机号"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <!-- <el-col :span="8" class="item">
                                        <el-form-item label="注册密码" required  prop="password">
                                            <el-input v-model="editForm.password" maxlength="11" type="password" placeholder="请输入注册密码" show-password></el-input>
                                        </el-form-item>
                                    </el-col> -->
                                    <el-col :span="8" class="item">
                                        <el-form-item label="卡号" >
                                            <el-input v-model="editForm.cardNumber" placeholder="请输入卡号"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" class="item">
                                        <el-form-item label="婚姻状况"  >
                                            <el-select v-model="editForm.isMarriage" placeholder="请选择婚姻状况" style="width:100%">
                                                <el-option
                                                        v-for="item in elderlyAllType.maritalValue"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" class="item">
                                        <el-form-item label="民族"  >
                                            <el-select v-model="editForm.nationId" filterable placeholder="请选择民族" style="width:100%">
                                                <el-option
                                                        v-for="item in nationValue"
                                                        :key="item.id"
                                                        :label="item.nation"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" class="item">
                                        <el-form-item label="政治面貌" >
                                            <el-select v-model="editForm.politicsStatus" placeholder="请选择政治面貌" style="width:100%">
                                                <el-option
                                                        v-for="item in elderlyAllType.politicalOutlook"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" class="item">
                                        <el-form-item label="文化程度" >
                                            <el-select v-model="editForm.education" placeholder="请选择文化程度" style="width:100%">
                                                <el-option
                                                        v-for="item in elderlyAllType.education"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" class="item">
                                        <el-form-item label="户籍性质" >
                                            <el-select v-model="editForm.censusRegister" placeholder="请选择户籍性质" style="width:100%">
                                                <el-option
                                                        v-for="item in elderlyAllType.natureHRegistrater"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="头像"  class="heardImg">
                                        <el-upload
                                                ref="heardImg"
                                                class="upload-demo"
                                                :action="uploadUrl"
                                                list-type="picture-card"
                                                :data='uploadData'
                                                :show-file-list="false"
                                                :on-success="handleImgSuccess"
                                                style="width:100%">
                                            <el-image v-if="editForm.heardImg" :src="editForm.heardImg" fit="cover" style="border-radius: 5px;" class="avatar"></el-image>
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </el-form-item>
                                </el-col>



                                <el-col :span="6" class="item">
                                    <el-form-item label="子女状况"  >
                                        <el-select v-model="editForm.children" placeholder="请选择子女状况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.children"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="6" class="item">
                                    <el-form-item label="地区"  >
                                        <el-cascader
                                                placeholder="请选择所属地区（可搜索）"
                                                v-model="editForm.areaCode"
                                                :options="areaValue"
                                                :props="props"
                                                filterable style="width:100%">
                                        </el-cascader>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="详细地址"  >
                                        <el-input v-model="editForm.homeAddress" disabled placeholder="请选择详细地址" class="homeAddress">
                                            <el-button slot="append" icon="el-icon-search" @click="openBaiduMap">选择</el-button>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="居住情况" >
                                        <el-select v-model="editForm.livingStatus" placeholder="请选择居住情况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.livingConditions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>服务信息</span>
                                </div>
                                <el-col :span="18">
                                    <el-col :span="8" class="item">
                                        <el-form-item label="服务类型" >
                                            <el-select v-model="editForm.elderlyType" placeholder="请选择服务类型" style="width:100%">
                                                <el-option
                                                        v-for="item in elderlyAllType.serviceType"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" class="item">
                                        <el-form-item label="补助类别"  >
                                            <el-select v-model="editForm.subsidy" placeholder="请选择补助类别" style="width:100%">
                                                <el-option
                                                        v-for="item in elderlyAllType.subsidy"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" class="item">
                                        <el-form-item label="服务状态"  >
                                            <el-select v-model="editForm.serviceStatus" placeholder="请选择服务状态" style="width:100%">
                                                <el-option
                                                        v-for="item in elderlyAllType.serviceStatus"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" class="item" v-if="disabled">
                                        <el-form-item label="老人类型" >
                                            <el-select v-model="editForm.elderlyClass" placeholder="请选择服务状态" style="width:100%">
                                                <el-option
                                                        v-for="item in elderlyAllType.elderlyClass"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <!-- <el-col :span="8" class="item">
                                        <el-form-item label="终端号码" required prop="terminalCode">
                                            <el-input v-model="editForm.terminalCode" placeholder="请输入终端号码"></el-input>
                                        </el-form-item>
                                    </el-col> -->
                                    <el-col :span="24" class="item">
                                        <el-form-item label="服务需求"  >
                                            <el-checkbox-group v-model="editForm.serviceDemand" style="margin-top:40px" >
                                                <el-checkbox v-for="item in elderlyAllType.serviceDemand" :label="item.value"  :key="item.value" >{{item.label}}</el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </el-col>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <!-- <div>老人二维码</div> -->
                                    <el-form-item label="老人二维码">
                                        <div class="canvas-code" id="qrcode" ></div>
                                    </el-form-item>
                                </el-col>
                            </el-card>

                            <el-image-viewer
                                    v-if="imgDialog"
                                    :on-close="imgClose"
                                    :url-list="srcList" />



                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>证件上传</span>
                                </div>
                                <el-row>
                                    <el-col :span="6" class="item">
                                        <el-form-item label="身份证正面" >
                                            <el-upload
                                                    class="upload-demo"
                                                    :action="uploadUrl"
                                                    list-type="picture-card"
                                                    :data='uploadData'
                                                    :show-file-list="false"
                                                    :on-success="idCardFrontSuccess"
                                                    style="width:100%">
                                                <el-image v-if="editForm.idCardFront" :src="editForm.idCardFront" style="border-radius: 5px;" class="avatarImg"></el-image>
                                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            </el-upload>
                                            <!--                                        <el-dialog :visible.sync="idCardFrontDialog" :modal-append-to-body='false'>-->
                                            <!--                                            <img width="100%" :src="editForm.idCardFront" alt="">-->
                                            <!--                                        </el-dialog>-->
                                            <!--                                        <div class="uploadButton" v-if="editForm.idCardFront">-->
                                            <!--                                            <el-button type="primary" size="small" @click="idCardFrontPreview">预览</el-button>-->
                                            <!--                                            <el-button type="success" size="small" @click="idCardFrontRemove">删除</el-button>-->
                                            <!--                                        </div>-->

                                            <div class="uploadButton" v-if="editForm.idCardFront">
                                                <el-button type="primary" size="small" @click="imgPreview(editForm.idCardFront)">预览</el-button>
                                                <el-button type="success" size="small" @click="idCardFrontRemove">删除</el-button>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6" class="item">
                                        <el-form-item label="身份证反面" >
                                            <el-upload
                                                    class="upload-demo"
                                                    :action="uploadUrl"
                                                    list-type="picture-card"
                                                    :data='uploadData'
                                                    :show-file-list="false"
                                                    :on-success="idCardContrarySuccess"
                                                    style="width:100%">
                                                <el-image v-if="editForm.idCardContrary" :src="editForm.idCardContrary" fit="cover" style="border-radius: 5px;" class="avatarImg"></el-image>
                                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            </el-upload>
                                            <!--                                        <el-dialog :visible.sync="idCardContraryDialog" :modal-append-to-body='false'>-->
                                            <!--                                            <img width="100%" :src="editForm.idCardContrary" alt="">-->
                                            <!--                                        </el-dialog>-->
                                            <!--                                        <div class="uploadButton" v-if="editForm.idCardContrary">-->
                                            <!--                                            <el-button type="primary" size="small" @click="idCardContraryPreview">预览</el-button>-->
                                            <!--                                            <el-button type="success" size="small" @click="idCardContraryRemove">删除</el-button>-->
                                            <!--                                        </div>-->
                                            <div class="uploadButton" v-if="editForm.idCardContrary">
                                                <el-button type="primary" size="small" @click="imgPreview(editForm.idCardContrary)">预览</el-button>
                                                <el-button type="success" size="small" @click="idCardContraryRemove">删除</el-button>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6" class="item">
                                        <el-form-item label="户口本正面" >
                                            <el-upload
                                                    class="upload-demo"
                                                    :action="uploadUrl"
                                                    list-type="picture-card"
                                                    :data='uploadData'
                                                    :show-file-list="false"
                                                    :on-success="householdFrontSuccess"
                                                    style="width:100%">
                                                <el-image v-if="editForm.householdFront" :src="editForm.householdFront" fit="cover" style="border-radius: 5px;" class="avatarImg" ></el-image>
                                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            </el-upload>
                                            <!--                                        <el-dialog :visible.sync="householdFrontDialog" :modal-append-to-body='false'>-->
                                            <!--                                            <img width="100%" :src="editForm.householdFront" alt="">-->
                                            <!--                                        </el-dialog>-->
                                            <!--                                        <div class="uploadButton" v-if="editForm.householdFront">-->
                                            <!--                                            <el-button type="primary" size="small" @click="householdFrontPreview">预览</el-button>-->
                                            <!--                                            <el-button type="success" size="small" @click="householdFrontRemove">删除</el-button>-->
                                            <!--                                        </div>-->
                                            <div class="uploadButton" v-if="editForm.householdFront">
                                                <el-button type="primary" size="small"  @click="imgPreview(editForm.householdFront)">预览</el-button>
                                                <el-button type="success" size="small" @click="householdFrontRemove">删除</el-button>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6" class="item">
                                        <el-form-item label="户口本老人所在页面" >
                                            <el-upload
                                                    class="upload-demo"
                                                    :action="uploadUrl"
                                                    list-type="picture-card"
                                                    :data='uploadData'
                                                    :show-file-list="false"
                                                    :on-success="householdContrarySuccess"
                                                    style="width:100%">
                                                <el-image v-if="editForm.householdContrary" :src="editForm.householdContrary" fit="cover" style="border-radius: 5px;" class="avatarImg" ></el-image>
                                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            </el-upload>
                                            <!--                                        <el-dialog :visible.sync="householdContraryDialog" :modal-append-to-body='false'>-->
                                            <!--                                            <img width="100%" :src="editForm.householdContrary" alt="">-->
                                            <!--                                        </el-dialog>-->
                                            <!--                                        <div class="uploadButton" v-if="editForm.householdContrary">-->
                                            <!--                                            <el-button type="primary" size="small" @click="householdContraryPreview">预览</el-button>-->
                                            <!--                                            <el-button type="success" size="small" @click="householdContraryRemove">删除</el-button>-->
                                            <!--                                        </div>-->
                                            <div class="uploadButton" v-if="editForm.householdContrary">
                                                <el-button type="primary" size="small" @click="imgPreview(editForm.householdContrary)">预览</el-button>
                                                <el-button type="success" size="small" @click="householdContraryRemove">删除</el-button>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="6" class="item" v-if="editForm.subsidy==1">
                                        <el-form-item label="低保证正面" >
                                            <el-upload
                                                    class="upload-demo"
                                                    :action="uploadUrl"
                                                    list-type="picture-card"
                                                    :data='uploadData'
                                                    :show-file-list="false"
                                                    :on-success="securityCardFrontSuccess"
                                                    style="width:100%">
                                                <el-image v-if="editForm.securityCardFront" :src="editForm.securityCardFront" fit="cover" style="border-radius: 5px;" class="avatarImg" ></el-image>
                                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            </el-upload>
                                            <!--                                        <el-dialog :visible.sync="securityCardFrontDialog" :modal-append-to-body='false'>-->
                                            <!--                                            <img width="100%" :src="editForm.securityCardFront" alt="">-->
                                            <!--                                        </el-dialog>-->
                                            <!--                                        <div class="uploadButton" v-if="editForm.securityCardFront">-->
                                            <!--                                            <el-button type="primary" size="small" @click="securityCardFrontPreview">预览</el-button>-->
                                            <!--                                            <el-button type="success" size="small" @click="securityCardFrontRemove">删除</el-button>-->
                                            <!--                                        </div>-->
                                            <div class="uploadButton" v-if="editForm.securityCardFront">
                                                <el-button type="primary" size="small"   @click="imgPreview(editForm.securityCardFront)">预览</el-button>
                                                <el-button type="success" size="small" @click="securityCardFrontRemove">删除</el-button>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6" class="item" v-if="editForm.subsidy==1">
                                        <el-form-item label="低保证老人所在页面" >
                                            <el-upload
                                                    class="upload-demo"
                                                    :action="uploadUrl"
                                                    list-type="picture-card"
                                                    :data='uploadData'
                                                    :show-file-list="false"
                                                    :on-success="securityCardContrarySuccess"
                                                    style="width:100%">
                                                <el-image v-if="editForm.securityCardContrary" :src="editForm.securityCardContrary" fit="cover" style="border-radius: 5px;"  class="avatarImg"></el-image>
                                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            </el-upload>
                                            <!--                                        <el-dialog :visible.sync="securityCardContraryDialog" :modal-append-to-body='false'>-->
                                            <!--                                            <img width="100%" :src="editForm.securityCardContrary" alt="">-->
                                            <!--                                        </el-dialog>-->
                                            <!--                                        <div class="uploadButton" v-if="editForm.securityCardContrary">-->
                                            <!--                                            <el-button type="primary" size="small" @click="securityCardContraryPreview">预览</el-button>-->
                                            <!--                                            <el-button type="success" size="small" @click="securityCardContraryRemove">删除</el-button>-->
                                            <!--                                        </div>-->
                                            <div class="uploadButton" v-if="editForm.securityCardContrary">
                                                <el-button type="primary" size="small"   @click="imgPreview(editForm.securityCardContrary)">预览</el-button>
                                                <el-button type="success" size="small" @click="securityCardContraryRemove">删除</el-button>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>紧急联系人</span>
                                </div>
                                <el-col :span="6" class="item"  >
                                    <el-form-item label="联系人"  >
                                        <el-input v-model="editForm.urgencyContact" placeholder="请输入联系人"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="紧急电话"  >
                                        <el-input v-model="editForm.urgencyPhone" maxlength="11" placeholder="请输入紧急电话"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="关系"   >
                                        <el-select v-model="editForm.relation" placeholder="请选择与紧急联系人的关系" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.relationship"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>健康状况</span>
                                </div>
                                <el-col :span="6" class="item">
                                    <el-form-item label="自理能力" >
                                        <!-- <el-form-item label="自理能力" required prop="selfCardAbility"> -->
                                        <el-select v-model="editForm.selfCardAbility" placeholder="请选择自理能力" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.selfCareAbility"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="心理状况">
                                        <!-- <el-form-item label="心理状况" required prop="psychologyStatus"> -->
                                        <el-select v-model="editForm.psychologyStatus" placeholder="请选择心理状况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.mentalState"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="血型" >
                                        <!-- <el-form-item label="血型" required prop="bloodType"> -->
                                        <el-select v-model="editForm.bloodType" placeholder="请选择血型" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.bloodType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="残疾情况" >
                                        <!-- <el-form-item label="残疾情况" required prop="disabilityStatus"> -->
                                        <el-select v-model="editForm.disabilityStatus" placeholder="请选择残疾情况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.disabilityType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item" v-if="editForm.disabilityStatus>0">
                                    <!-- <el-form-item label="残疾等级"> -->
                                    <el-form-item label="残疾等级" >
                                        <el-select v-model="editForm.disabilityLevel" placeholder="请选择残疾等级" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.disabilityLevel"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="过敏药物">
                                        <!-- <el-form-item label="过敏药物" required prop="irritabilityMedicine"> -->
                                        <el-input v-model="editForm.irritabilityMedicine" placeholder="请输入过敏药物"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="医疗保障情况" >
                                        <!-- <el-form-item label="医疗保障情况" required prop="medicalSecurityStatus"> -->
                                        <el-select v-model="editForm.medicalSecurityStatus" placeholder="请选择医疗保障情况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.medicalSecurity"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="主要疾病" >
                                        <!-- <el-form-item label="主要疾病" required prop="illness"> -->
                                        <el-input v-model="editForm.illness" placeholder="请输入主要疾病"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="是否手术" >
                                        <!-- <el-form-item label="是否手术" required prop="isOperation"> -->
                                        <el-select v-model="editForm.isOperation" placeholder="请选择是否手术" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.status"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item"  v-if="editForm.isOperation===0">
                                    <el-form-item label="手术原因" >
                                        <el-input v-model="editForm.operationCause" placeholder="请输入手术原因"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item" v-if="editForm.isOperation===0">
                                    <el-form-item label="手术时间" >
                                        <el-date-picker
                                                v-model="editForm.operationTime"
                                                type="date"
                                                placeholder="请选择手术日期"
                                                :picker-options="pickerOptions0"
                                                style="width:100%">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>生活方式</span>
                                </div>
                                <el-col :span="6" class="item">
                                    <el-form-item label="饮食习惯"  >
                                        <el-select v-model="editForm.dietaryHabit" placeholder="请选择饮食习惯" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.dietHabits"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="忌食"  >
                                        <el-input v-model="editForm.diet" placeholder="请输入忌食"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="吸烟状况" >
                                        <el-select v-model="editForm.smokeStatus" placeholder="请选择吸烟状况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.smokeType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="饮酒频率">
                                        <el-select v-model="editForm.drinkStatus" placeholder="请选择饮酒频率" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.drinkType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item" v-if="editForm.drinkStatus>0">
                                    <el-form-item label="饮酒种类" >
                                        <el-input v-model="editForm.drinkKind" placeholder="请输入饮酒种类"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="体育锻炼方式" >
                                        <el-input v-model="editForm.exerciseType" placeholder="请输入体育锻炼方式"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item" v-if="editForm.exerciseType && editForm.exerciseType!='无'">
                                    <el-form-item label="锻炼频率"  >
                                        <el-select v-model="editForm.exerciseStatus" placeholder="请选择锻炼频率" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.exercise"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item" v-if="editForm.exerciseType && editForm.exerciseType!='无'">
                                    <el-form-item label="每次锻炼时间" >
                                        <el-select v-model="editForm.exerciseTime" placeholder="请选择每次锻炼时间" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.exerciseTime"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>兴趣爱好</span>
                                </div>
                                <el-col :span="24" class="item">
                                    <el-form-item label="兴趣爱好" >
                                        <!-- <el-input v-model="editForm.interest" placeholder="请输入您的兴趣爱好"></el-input> -->
                                        <el-checkbox-group v-model="editForm.interest" style="margin-top:40px" >
                                            <el-checkbox v-for="item in elderlyAllType.likeValue" :label="item.value"  :key="item.value" >{{item.label}}</el-checkbox>
                                        </el-checkbox-group>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>经济状况</span>
                                </div>
                                <el-col :span="6" class="item">
                                    <el-form-item label="经济来源"  >
                                        <el-select v-model="editForm.pocketbook" placeholder="请选择经济来源" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.economicSources"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="月收入"  >
                                        <el-input v-model="editForm.monthlyIncome" placeholder="请输入您的月收入"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="月消费" >
                                        <el-input v-model="editForm.monthlyConsumption" placeholder="请输入您的月消费"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>亲属信息</span>
                                    <el-button style="float: right;transform: translate(-19px, -9px);" type="primary" @click="showForm">添加亲属</el-button>
                                </div>

                                <el-col :span="24" class="item">
                                    <el-table
                                            :data="relativesInfo"
                                            style="width: 100%" border>
                                        <el-table-column
                                                prop="name"
                                                label="亲属姓名">
                                        </el-table-column>
                                        <el-table-column
                                                prop="phone"
                                                label="联系电话">
                                        </el-table-column>
                                        <el-table-column
                                                prop="relation"
                                                :formatter="relations"
                                                label="与老人关系">
                                        </el-table-column>
                                        <el-table-column
                                                prop="workUnit"
                                                label="工作单位">
                                        </el-table-column>
                                        <el-table-column
                                                prop="address"
                                                label="地址">
                                        </el-table-column>
                                        <el-table-column fixed="right" label="操作" width="120">
                                            <template slot-scope="scope">
                                                <el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">删除</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-card>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" v-if="showFoot" @click="confirm('editForm')">编辑</el-button>
                <el-button type="success" @click="closeSelf">关闭</el-button>
            </div>
        </div>
<!--        <BaiduMap ref="baiduMap" v-show="baiduMapShow"  v-on:colseMap="colseMap" v-on:setMap="setMap"></BaiduMap>-->
<!--        <RelativesAdd ref="relativesAdd" v-show="relativeShow"  v-on:showForm="showForm"  v-on:relativeConfirm="relativeConfirm"></RelativesAdd>-->
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    // import RelativesAdd from "./RelativesAdd";
    import QRCode  from "qrcodejs2"
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
    // import elderly from "@/common/status";
    // import elderly from "@/common/status";
    export default {
        name: 'Add',
        props: ['nationValue','zoneValue','areaValue','elderlyAllType'],
        data() {
            return {
                srcList:[],
                header:'',
                disabled:true,
                imgDialog: false,
                // idCardFrontDialog: false,
                baiduMapShow: false,
                elderly:'',
                // idCardContraryDialog: false,
                // householdFrontDialog: false,
                // householdContraryDialog: false,
                // securityCardFrontDialog: false,
                // securityCardContraryDialog: false,
                loading: false,
                relativeShow:false,
                showFoot:false,
                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                relativesInfo:[],
                props: {
                    emitPath:false,
                    value: 'areaCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listAreaDTO'
                },
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
                //时间范围限制
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6
                    }
                },
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e6
                    }
                },
                options: [],
                parentAreaCode:'00000000-0000-0000-0000-000000000000',
                editForm:{
                    timeStr:timeStr,
                    sign:null,
                    phone:null,
                    isMarriage:null,
                    dietaryHabit:null,
                    phones:null,
                    exerciseTime:'',
                    isOperation:null,
                    cardNumber:null,
                    disabilityLevel:'',
                    subsidy:null,
                    children:null,
                    elderlyClassCode:null,
                    elderlyClass:null,
                    areaCode:null,
                    kinsfolk:null,
                    elderlyType:null,
                    bloodType:null,
                    zoneCode:null,
                    urgencyContact:null,
                    urgencyPhone:null,
                    staffCode:getStaffCode(),
                    name:null,
                    memberLevel:null,
                    monthlyConsumption:'',
                    cardInsideCode:null,
                    cardCoding:null,
                    idCard:null,
                    operationCause:'',
                    nationId:null,
                    lat:null,
                    drinkStatus:null,
                    drinkKind:'',
                    politicsStatus:null,
                    medicalSecurityStatus:null,
                    illness:'',
                    pocketbook:null,
                    censusRegister:null,
                    livingStatus:null,
                    exerciseStatus:'',
                    terminalCode:null,
                    serviceDemand:[],
                    diet:'',
                    relation:null,
                    interest:[],
                    // password:'123456',
                    selfCardAbility:null,
                    disabilityStatus:null,
                    irritabilityMedicine:'',
                    periodOfValidity:null,
                    psychologyStatus:null,
                    exerciseType:'',
                    education:null,
                    smokeStatus:null,
                    heardImg:null,
                    homeAddress:null,
                    lon:null,
                    monthlyIncome:'',
                    operationTime:'',
                    serviceStatus:'',
                    elderlyCode:'',
                    idCardFront:null,
                    idCardContrary:null,
                    householdFront:null,
                    householdContrary:null,
                    securityCardFront:null,
                    securityCardContrary:null,
                },
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                goodslist:"",
                // elderlyAllType:elderly
            }
        },
        components:{
            ElImageViewer
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.bodyStyle = "height:"+(val+50)+'px';
            },
        },
        methods: {
            init(row,isInfo){
                console.log(row.kinsfolk);
                this.elderly=row.elderly;
                this.disabled=isInfo;
                this.showFoot=!isInfo;
                if(isInfo){
                    this.header='服务对象详情'
                }else{
                    this.header='服务对象编辑'
                }
                var appNav=document.getElementsByClassName('app-nav');
                this.goodslist="left:"+appNav[0].scrollWidth+'px'
                this.editForm.elderlyCode = this.elderly.elderlyCode;
                document.getElementById("qrcode").innerHTML = "";
                this.$nextTick (function () {
                    this.qrcodeInit();
                })
                this.editForm.name =  this.elderly.name;
                if(this.elderly.idCardFront){
                    this.editForm.idCardFront = this.$imgUrl+this.elderly.idCardFront;
                    this.srcList.push(this.editForm.idCardFront)
                }else{
                    this.editForm.idCardFront =null
                }
                if(this.elderly.idCardContrary){
                    this.editForm.idCardContrary = this.$imgUrl+this.elderly.idCardContrary;
                    this.srcList.push(this.editForm.idCardContrary)
                }
                else{
                    this.editForm.idCardContrary =null
                }
                if(this.elderly.householdFront){
                    this.editForm.householdFront = this.$imgUrl+this.elderly.householdFront;
                    this.srcList.push(this.editForm.householdFront)
                }else{
                    this.editForm.householdFront =null
                }
                if(this.elderly.householdContrary){
                    this.editForm.householdContrary = this.$imgUrl+this.elderly.householdContrary;
                    this.srcList.push(this.editForm.householdContrary)
                }else{
                    this.editForm.householdContrary =null
                }
                if(this.elderly.securityCardFront){
                    this.editForm.securityCardFront = this.$imgUrl+this.elderly.securityCardFront;
                    this.srcList.push(this.editForm.securityCardFront)
                }else{
                    this.editForm.securityCardFront =null
                }
                if(this.elderly.securityCardContrary){
                    this.editForm.securityCardContrary = this.$imgUrl+this.elderly.securityCardContrary;
                    this.srcList.push(this.editForm.securityCardContrary)
                }else{
                    this.editForm.securityCardContrary =null
                }
                if(this.elderly.heardImg){
                    this.editForm.heardImg =  this.$imgUrl+this.elderly.heardImg;
                }else{
                    this.editForm.heardImg =null
                }
                this.editForm.exerciseTime = this.elderly.exerciseTime;
                this.editForm.cardNumber = this.elderly.cardNumber;
                this.editForm.elderlyClassCode = this.elderly.elderlyClassCode;
                this.editForm.elderlyClass = this.elderly.elderlyClass;
                if(this.elderly.areaCode){
                    this.editForm.areaCode = '';
                }
                this.editForm.elderlyType = this.isSelectTwo(this.elderly.elderlyType);

                this.editForm.zoneCode = this.elderly.zoneCode;
                this.editForm.urgencyContact = this.elderly.urgencyContact;
                this.editForm.urgencyPhone = this.elderly.urgencyPhone;
                this.editForm.memberLevel = this.elderly.memberLevel;
                this.editForm.monthlyConsumption = this.elderly.monthlyConsumption;
                this.editForm.cardInsideCode = this.elderly.cardInsideCode;
                this.editForm.cardCoding = this.elderly.cardCoding;
                this.editForm.socialSecurityCode = this.elderly.socialSecurityCode;
                this.editForm.idCard = this.elderly.idCard;
                this.editForm.operationCause = this.elderly.operationCause;
                if(this.elderly.interest){
                    this.editForm.interest =  JSON.parse(this.elderly.interest);
                }
                this.editForm.drinkKind = this.elderly.drinkKind;
                this.editForm.illness = this.elderly.illness;
                this.editForm.phone = this.elderly.phone;
                this.editForm.terminalCode = this.elderly.terminalCode;
                this.editForm.areaCode = this.elderly.areaCode;
                if(this.elderly.kinsfolk){
                    this.editForm.kinsfolk = JSON.parse(this.elderly.kinsfolk);
                }
                this.relativesInfo=this.editForm.kinsfolk
                if(this.elderly.serviceDemand){
                    this.editForm.serviceDemand = JSON.parse(this.elderly.serviceDemand);
                }
                this.editForm.diet = this.elderly.diet;
                this.editForm.irritabilityMedicine =this.elderly.irritabilityMedicine;
                this.editForm.periodOfValidity = this.elderly.periodOfValidity;
                this.editForm.exerciseType = this.elderly.exerciseType;
                this.editForm.homeAddress =this.elderly.homeAddress;
                this.editForm.monthlyIncome = this.elderly.monthlyIncome;
                // this.editForm.sort = row.sort;
                this.editForm.status = this.elderly.status;
                this.editForm.isMarriage = this.isSelectTwo(this.elderly.isMarriage);
                this.editForm.subsidy = this.isSelectTwo(this.elderly.subsidy);
                this.editForm.children = this.isSelectTwo(this.elderly.children);
                this.editForm.nationId = this.isSelectTwo(this.elderly.sysNation);
                this.editForm.politicsStatus = this.isSelectTwo(this.elderly.politicsStatus);
                this.editForm.censusRegister = this.isSelectTwo(this.elderly.censusRegister);
                this.editForm.livingStatus = this.isSelectTwo(this.elderly.livingStatus);
                this.editForm.serviceStatus = this.isSelectTwo(this.elderly.serviceStatus);
                this.editForm.relation = this.isSelectTwo(this.elderly.relation);
                this.editForm.education = this.isSelectTwo(this.elderly.education);
                this.editForm.selfCardAbility=this.isSelectTwo(this.elderly.selfCardAbility)
                this.editForm.psychologyStatus=this.isSelectTwo(this.elderly.psychologyStatus)
                this.editForm.bloodType=this.isSelectTwo(this.elderly.bloodType)
                this.editForm.disabilityStatus=this.isSelectTwo(this.elderly.disabilityStatus)
                this.editForm.medicalSecurityStatus=this.isSelectTwo(this.elderly.medicalSecurityStatus)
                this.editForm.isOperation=this.isSelectTwo(this.elderly.isOperation)
                this.editForm.dietaryHabit=this.isSelectTwo(this.elderly.dietaryHabit)
                this.editForm.smokeStatus=this.isSelectTwo(this.elderly.smokeStatus)
                this.editForm.drinkStatus=this.isSelectTwo(this.elderly.drinkStatus)
                this.editForm.pocketbook=this.isSelectTwo(this.elderly.pocketbook)
                this.editForm.disabilityLevel=this.isSelectTwo(this.elderly.disabilityLevel)
                this.editForm.exerciseStatus=this.isSelectTwo(this.elderly.exerciseStatus)
                this.editForm.exerciseType=this.isSelect(this.elderly.exerciseType)
                // this.$refs.editForm.resetFields();
            },
            //  生成二维码
            qrcodeInit () {
                new QRCode('qrcode', {
                    width: 250,
                    height: 250,        // 高度
                    text:  this.elderly.elderlyCode,   // 二维码内容
                    colorDark : "#000000",
                    colorLight : "#ffffff",
                    correctLevel : QRCode.CorrectLevel.H
                })
            },
            closeSelf() {
                this.loading = false;
                this.$emit("close");

            },
            setMap(info){
                console.log(info)
                this.editForm.homeAddress=info.addressInfo
                this.editForm.lon=info.lng
                this.editForm.lat=info.lat
                this.baiduMapShow=false
            },
            handleAreaChange(){
                var thsAreaCode = this.$refs.cascaderAddr.getCheckedNodes()
                this.thsArea=thsAreaCode[0].parent.label
            },
            openBaiduMap(){
                if(!this.editForm.areaCode){
                    this.$message({type: 'info', message: '请选择地区'});
                    return;
                }
                this.$refs.baiduMap.init(this.thsArea);
                this.baiduMapShow=true;
            },
            colseMap(){
                this.baiduMapShow=false
            },
            handleImgSuccess(res, file) {
                console.log(file)
                this.editForm.heardImg = this.$imgUrl+res.data.path;
            },
            handleChange(val){
                if(val.length){
                    this.editForm.areaCode=val[val.length-1]
                }
                console.log(this.editForm.areaCode)
            },
            idCardFrontSuccess(res, file) {
                console.log(file)
                this.editForm.idCardFront = this.$imgUrl+res.data.path;
            },
            idCardContrarySuccess(res, file) {
                console.log(file)
                this.editForm.idCardContrary = this.$imgUrl+res.data.path;
            },
            householdFrontSuccess(res, file) {
                console.log(file)
                this.editForm.householdFront = this.$imgUrl+res.data.path;
            },
            householdContrarySuccess(res, file) {
                console.log(file)
                this.editForm.householdContrary = this.$imgUrl+res.data.path;
            },
            securityCardFrontSuccess(res, file) {
                console.log(file)
                this.editForm.securityCardFront = this.$imgUrl+res.data.path;
            },
            securityCardContrarySuccess(res, file) {
                console.log(file)
                this.editForm.securityCardContrary = this.$imgUrl+res.data.path;
            },
            idCardFrontPreview( file) {
                console.log(file)
                // this.dialogIdCardValue = file.url;
                this.idCardFrontDialog = true;
            },
            idCardFrontRemove() {
                this.editForm.idCardFront = '';
            },

            imgPreview(url){
                this.srcList=this.getPreviewList(url)
            },

            imgClose() {this.imgDialog = false;},

            // idCardContraryPreview() {this.idCardContraryDialog = true;},
            idCardContraryRemove() {this.editForm.idCardContrary = '';},
            // householdFrontPreview() {this.householdFrontDialog = true;},
            householdFrontRemove() {this.editForm.householdFront = '';},
            // householdContraryPreview() {this.householdContraryDialog = true;},
            householdContraryRemove() {this.editForm.householdContrary = '';},
            // securityCardFrontPreview() {this.securityCardFrontDialog = true;},
            securityCardFrontRemove() {this.editForm.securityCardFront = '';},
            // securityCardContraryPreview() {this.securityCardContraryDialog = true;},
            securityCardContraryRemove() {this.editForm.securityCardContrary = '';},

            getPreviewList(url){
                this.imgDialog = true;
                var list=[]
                var list1=this.srcList;
                for(var i in list1){
                    if(list1[i]==url){
                        var str =list1.slice(i)
                        list=str.concat(list)
                        return list
                    }else{
                        list.push(list1[i])
                    }
                }
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message({type: 'warning', message: '请完善信息'});
                        return false;
                    }
                })

            },
            showForm(){
                this.relativeShow=!this.relativeShow;
            },
            relativeConfirm(relativeForm){
                this.relativesInfo.push(relativeForm);
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                // if(this.editForm.heardImg==null){
                //     this.$message({type: 'info', message: '请上传头像'});
                //     this.loading = false;
                //     return;
                // }
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.editForm.kinsfolk =this.relativesInfo;
                this.editForm.selfCardAbility=this.isSelect(this.editForm.selfCardAbility)
                this.editForm.psychologyStatus=this.isSelect(this.editForm.psychologyStatus)
                this.editForm.bloodType=this.isSelect(this.editForm.bloodType)
                this.editForm.disabilityStatus=this.isSelect(this.editForm.disabilityStatus)
                this.editForm.medicalSecurityStatus=this.isSelect(this.editForm.medicalSecurityStatus)
                this.editForm.isOperation=this.isSelect(this.editForm.isOperation)
                this.editForm.dietaryHabit=this.isSelect(this.editForm.dietaryHabit)
                this.editForm.smokeStatus=this.isSelect(this.editForm.smokeStatus)
                this.editForm.drinkStatus=this.isSelect(this.editForm.drinkStatus)
                this.editForm.relation=this.isSelect(this.editForm.relation)
                this.editForm.pocketbook=this.isSelect(this.editForm.pocketbook)
                this.editForm.isMarriage=this.isSelect(this.editForm.isMarriage)
                this.editForm.politicsStatus=this.isSelect(this.editForm.politicsStatus)
                this.editForm.nationId=this.isSelect(this.editForm.nationId)
                this.editForm.education=this.isSelect(this.editForm.education)
                this.editForm.censusRegister=this.isSelect(this.editForm.censusRegister)
                this.editForm.exerciseType=this.isExerciseType(this.editForm.exerciseType)
                console.log("2"+this.editForm.exerciseType)

                if(this.editForm.heardImg){
                    this.editForm.heardImg =this.editForm.heardImg.replace(this.$imgUrl,'')
                }
                if(this.editForm.idCardFront){
                    this.editForm.idCardFront=this.editForm.idCardFront.replace(this.$imgUrl,'')
                }
                if(this.editForm.idCardContrary){
                    this.editForm.idCardContrary=this.editForm.idCardContrary.replace(this.$imgUrl,'')
                }
                if(this.editForm.householdFront){
                    this.editForm.householdFront=this.editForm.householdFront.replace(this.$imgUrl,'')
                }
                if(this.editForm.householdContrary){
                    this.editForm.householdContrary=this.editForm.householdContrary.replace(this.$imgUrl,'')
                }
                if(this.editForm.securityCardFront){
                    this.editForm.securityCardFront=this.editForm.securityCardFront.replace(this.$imgUrl,'')
                }
                if(this.editForm.securityCardContrary){
                    this.editForm.securityCardContrary=this.editForm.securityCardContrary.replace(this.$imgUrl,'')
                }

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Elderly/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            // isRelation(data){
            //     if(data==-1){
            //         return -1
            //     }else{
            //         return data
            //     }
            // },
            isSelect(data){
                if(data==null){
                    return -1
                }else{
                    return data
                }
            },
            isSelectTwo(data){
                if(data==-1){
                    return null
                }else{
                    return data
                }
            },
            isExerciseType(data){
                if(data==-1){
                    return ""
                }else{
                    return data
                }
            },
            relations(row){
                return this.allStatus(row.relation,this.elderlyAllType.relationship);
            },
            allStatus(row,status){
                for(var i in status){
                    if(status[i].value==row){
                        return status[i].label
                    }
                }
                return "其它";
            }

        },
    }


</script>



<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .add_title{
                margin-left: 20px;
                font-size: 16px;
            }
            .modal-body .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .modal-body .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }
            .modal-body .heardImg .avatar-uploader-icon {
                font-size: 20px;
                color: #8c939d;
                width: 250px;
                height: 250px;
                line-height: 250px;
                text-align: center;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 20px;
                color: #8c939d;
                width: 180px;
                height: 180px;
                line-height: 180px;
                text-align: center;
            }
            .homeAddress  /deep/ .el-input__inner{
                background: #fff;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 20px;
                color: #8c939d;
                width: 180px;
                height: 180px;
                line-height: 180px;
                text-align: center;
            }
            .modal-body .avatar {
                width: 250px;
                height: 250px;
                display: block;
            }
            .modal-body .heardImg  /deep/ .el-upload--picture-card{
                width:250px;
                height: 250px;
                line-height: 250px;
            }
            .modal-body  /deep/ .el-upload--picture-card{
                width:100%;
                height: 180px;
                line-height: 180px;
            }
            .modal-body  .avatarImg{
                width:100%;
                height: 180px;
                line-height: 180px;
            }
            .uploadButton{
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 10px 0 0;
                display: flex;
                .el-button{
                    width: 35%;
                }
            }
            .upload-demo{
                margin-top: 40px;
            }
            .modal-body /deep/ .el-divider{
                margin: 10px 0px 0px;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-body /deep/ .el-input.is-disabled .el-input__inner {
                color: #000;
            }
            .modal-body /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
                border-color: #fff;
            }
            .modal-body /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
                background-color: #409EFF;
                border-color: #409EFF
            }
            .modal-body /deep/ .el-checkbox__input.is-disabled+span.el-checkbox__label {
                color:#606266;
            }
            .canvas-code{
                background:#fff;
                width:250px;
                height: 250px;
                margin: 40px 0;
                padding: 5px;
            }
            .modal-body {
                position: relative;
                padding: 0px 0px 20px;
                z-index: 99;
                overflow-y:scroll;
                height:500px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }



        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
